import { useShortcuts, ShortcutMode } from './useShortcut';

export function useSequentialNumericShortcuts(
  setIndex: (_a: number) => void,
  disabled: boolean,
  mode?: ShortcutMode,
) {
  const shortcuts = [...'0123456789'].map(num => ({
    trigger: num,
    action: () => {
      setIndex(parseInt(num));
    },
    description: `Set index ${num}`,
    disabled,
    forceNotEditable: true,
    mode,
  }));

  useShortcuts(shortcuts);
}

export const ALPHABETIC_SHORTCUTS = ['a', 's', 'd', 'f', 'j', 'k', 'l', ';'];

export function useSequentialAlphabeticShortcuts(
  setChoice: (_a: number) => void,
  disabled: boolean,
  mode?: ShortcutMode,
  filterInput?: boolean,
) {
  const shortcuts = ALPHABETIC_SHORTCUTS.map((letter, idx) => ({
    trigger: letter,
    action: () => {
      setChoice(idx);
    },
    description: `Set choice ${letter}`,
    disabled,
    forceNotEditable: true,
    mode,
    filterInput,
  }));

  useShortcuts(shortcuts);
}
